export default{
    与我们联系:"与我们联系",
    专属客户经理将尽快联系您:"",
    立即参与:"立即参与",
    提交:"提交"
}